import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { DateInput } from 'semantic-ui-calendar-react'
import { Form } from 'semantic-ui-react'
import { FarmersService } from '~/api/services/farmers/index'
import MilkMoneyAccountingService from '~/api/services/milkMoneyAccounting'
import CustomInput from '~/components/CustomInput'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import { useAuth } from '~/routes/components/AuthProvider'
import { handleErrors } from '~/utils/helpers'

interface EditArticleBookingProps {
  articleBookingId: string
  handleClose: (submited?: boolean) => void
  amount: string
  startBookingDate: string
  farmer: string
}

const EditArticleBooking: React.FC<EditArticleBookingProps> = (props) => {
  const { articleBookingId, handleClose, startBookingDate } = props
  const { id } = useParams()
  const { t } = useTranslation()
  const { systemData: { languages, logged: { languageId } } } = useAuth()
  const languageLocal = languages.find(language => language.id === languageId)

  const [isBusy, setIsBusy] = useState(false)
  const [lastMonth, setLastMonth] = useState(null)
  const [dateFrom, setDateFrom] = useState('')
  const [amount, setAmount] = useState('')

  useEffect(() => {
    if (articleBookingId) {
      fetchArticleBookingData()
    }
  }, [articleBookingId])

  async function fetchArticleBookingData() {
    try {
      const response = await MilkMoneyAccountingService.articleSettingsData(id)
      setLastMonth(Boolean(response.data?.lastMonth))
      setAmount(props.amount)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  const handleKeyPress = (event) => {
    event.preventDefault();
  }

  const todayDate = dayjs(new Date()).format('DD.MM.YYYY')

  function renderFormUpdate() {
    return <Form>
      <Form.Group widths={'equal'}>
        <Form.Field required>
          <label>{t('Date from')}</label>
          <DateInput
            name='dateTime'
            onKeyPress={handleKeyPress}
            placeholder={t('Booking start date')}
            clearable
            closable
            minDate={dayjs(startBookingDate).format('DD.MM.YYYY')}
            autoComplete='off'
            maxDate={todayDate}
            markColor={'blue'}
            localization={languageLocal.code}
            closeOnMouseLeave={false}
            dateFormat={'DD.MM.YYYY'}
            className={'datePicker'}
            value={dateFrom}
            iconPosition='left'
            onChange={(event, { name, value }) => setDateFrom(value)}
          />
        </Form.Field>
        <Form.Field required>
          <label>{t('Amount')}</label>
          <CustomInput
            value={amount}
            placeholder={t('Enter amount')}
            allowDecimals={false}
            onChange={(value) => setAmount(value)}
          />
        </Form.Field>
      </Form.Group>
    </Form>

  }

  function parseDate(value) {
    const arrayOfValues = value.split('.')
    return `${arrayOfValues[2]}-${arrayOfValues[1]}-${arrayOfValues[0]}`
  }

  async function handleUpdateBookmark() {
    setIsBusy(true)
    try {
      await FarmersService.updateFarmerArticle(id, articleBookingId, { dateFrom: parseDate(dateFrom), amount })
      handleCloseModal(true)
      notify(t('Successfully update article booking'), 'success')
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function handleCloseModal(submited = false) {
    setDateFrom('')
    setAmount('')
    handleClose(submited)
  }

  return <Dialog
    isDialogOpen={Boolean(articleBookingId)}
    textHeader={t('Edit article booking for farmer: {{farmer}}', { farmer: props.farmer })}
    textSubmit={t('Update')}
    isLoading={isBusy}
    textClose={t('Cancel')}
    textContent={<>
      {renderFormUpdate()}
    </>}
    handleSubmit={() => handleUpdateBookmark()}
    handleClose={() => handleCloseModal()}
  />
}
export default EditArticleBooking